import './App.css';
import Calculator from './Calculatur';

function App() {
  return (
    <div className="App">
      <header className="App-header">
       <Calculator/>
      </header>
    </div>
  );
}

export default App;
